<template>
  <div class="coreProduct">
    <div class="top_list_img">
      <img class="image_" src="/status/ecfd4938-1949-4af7-a8af-94c2e0791651.png">
      <div class="top_list_">
        <div class="text">核心产品医疗产品</div>
        <div class="title">核心医疗产品，赋能智慧就医</div>
      </div>
    </div>
    <div class="middle_box_list">
      <div class="top_list" >
        <div :class="tarIndex == index ?'tar_info blue':'tar_info'" v-for="(item,index) in tarList" :key="index" @click="select(index)">
          <div class="item">{{item}}</div>
          <div v-if="index != 4" class="border_info"></div>
        </div>
      </div>
      <div class="core_list">
        <div class="core_info" v-for="(item,index) in coreProductList[tarIndex]" :key="index" @click.prevent.stop="toCheck(item)">
          <div class="image">
            <img class="image_img" :src="item.img">
            <img class="imgInfo" v-if="item.imgInfo" :src="item.imgInfo">
          </div>
          <div class="right_info">
           <div>
             <div class="name">
               {{item.name}}
             </div>
             <div class="info">{{item.info}}</div>
           </div>
            <div class="btn_list">
              <div class="phone">
                <img src="/status/dianhua.png">
                <div>400-022-9558</div>
              </div>
              <div class="sub" @click.prevent.stop="makeCall">联系我们</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import {coreProductList} from '@/views/mock'
import tail_menu from "@/components/tail_menu_phone";
export default {
  name: "coreProduct",
  components:{
    tail_menu,
  },

  data(){
    return{
      coreProductList:coreProductList,
      tarIndex:0,
      phoneNumber:'400-022-9558',
      tarList:[
        '智慧医疗',
        '智慧病房',
        '智慧门诊',
        '互联网医疗',
        '医疗器械'
      ]
    }
  },
  created(){
    this.tarIndex = this.$route.query.fid
  },
  methods:{
    makeCall() {
      window.location.href = `tel:${this.phoneNumber}`;
    },
    select(index){
      this.tarIndex = index
    },
    toCheck(item) {
      this.$router.push({name: 'coreProductInfoPhone', query: {id: item.id,fid:this.tarIndex}})
    }
  }
}
</script>

<style scoped lang="scss">
.coreProduct{
  .top_list_img{
    position: relative;
    .image_{
      width: 100%;
      height: 800px;
      object-fit: cover;
    }
    .top_list_{
      position: absolute;
      top: 150px;
      left: 100px;
      color: white;
      .text{
        font-size: 120px;
      }
      .title{
        font-size: 50px;
      }
    }
  }

  .middle_box_list{
    display: flex;
    align-items: center;
    flex-direction: column;
    .top_list{
      display: flex;
      justify-content: space-around;
      padding: 14px 0;
      .tar_info{
        padding: 20px 0;
        justify-content: center;
        cursor: pointer;
        font-weight: bold;
        font-size: 50px;
        display: flex;
        .item{
          white-space: nowrap;
          margin-left: 40px;
          margin-right: 40px;
        }
        .border_info{
          background: rgb(216,216,216);
          width: 2px;
          height: 100%;
        }
      }
      .blue{

        border-bottom: 2px solid #4a7bac;
        color: #4a7bac;
      }
    }
    .core_list{
      .core_info{
        cursor: pointer;
        background: white;
        padding: 30px;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        margin-top: 30px;
        margin-bottom: 50px;
        border-radius: 8px;
        width: 1500px;
        display: flex;

        .image{
          position: relative;
          .image_img{
            width: 480px;
            height: 460px;
          }
          .imgInfo{
            position: absolute;
            left: 62px;
            top: 68px;
            width: 354px;
          }
        }
        .right_info{
          margin-top: 10px;
          margin-left: 30px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name{
            font-size: 57px;
          }
          .info{
            font-size: 42px;
            margin-top: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            color: #9B9B9B;
          }
          .btn_list{
            display: flex;
            font-size: 48px;
            .phone{
              border: 2px solid rgb(63,170,249);
              width:450px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 30px 20px;
              color: rgb(63,170,249);
              border-radius: 14px;
              font-weight: bold;

              img{
                width: 52px;
                margin-right: 4px;
              }
            }
            .sub{
              padding: 30px 20px;
              background: rgb(63,170,249);
              color: white;
              text-align: center;
              border-radius: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 350px;
              margin-left: 60px;
            }
          }
        }

      }
    }
  }
}
</style>
